/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {NgswCommChannel as ɵangular_packages_service_worker_service_worker_a} from './src/low_level';
export {SCRIPT as ɵangular_packages_service_worker_service_worker_b,ngswAppInitializer as ɵangular_packages_service_worker_service_worker_c,ngswCommChannelFactory as ɵangular_packages_service_worker_service_worker_d} from './src/module';